<script lang="ts" setup>
import { toRefs } from "vue";
import { ForwardSlots } from "vue-forward-slots";
import { VAutocomplete } from "vuetify/components";

import { type FieldInputProps, useFormInput } from "./use-form-input";

interface AutocompleteFieldProps extends FieldInputProps {
  persistentHint?: boolean;
}

const props = withDefaults(defineProps<AutocompleteFieldProps>(), {
  disabled: false,
  hint: "",
  label: undefined,
  persistentHint: true,
  type: "text",
});

// NOTE: Must redefine expected Vuetify "child" slots for types to work with 'vue-forward-slots'!
defineSlots<VAutocomplete["$slots"]>();

defineOptions({
  // Must prevent attributes from falling through to 'ForwardSlots' (instead bind to Vuetify component)!
  inheritAttrs: false,
});

const { disabled, error, field } = useFormInput(toRefs(props));
const { value: formValue, handleBlur, handleChange } = field;
</script>

<template>
  <ForwardSlots :slots="$slots">
    <VAutocomplete
      v-bind="$attrs"
      :disabled="disabled || props.disabled"
      :error="!!error"
      :hint="error ?? hint"
      :label="label"
      :model-value="formValue"
      :persistent-hint="!!error || persistentHint"
      @blur="handleBlur"
      @update:model-value="handleChange"
    />
  </ForwardSlots>
</template>
